<script lang="ts">
  import { fly } from "svelte/transition";
  import { backOut } from "svelte/easing";
  import { ApiError } from "../lib/api/client.js";
  import { session } from "../lib/stores/session.svelte.js";

  let email = $state("");
  let password = $state("");
  let error = $state("");
  let busy = $state(false);
  let shake = $state(0);

  async function submit(event: SubmitEvent): Promise<void> {
    event.preventDefault();
    if (busy) return;
    busy = true;
    error = "";
    try {
      await session.login(email.trim(), password);
    } catch (err) {
      error =
        err instanceof ApiError && err.status !== 0
          ? err.message
          : "Der Server ist nicht erreichbar – bitte später erneut versuchen.";
      shake += 1;
      password = "";
    } finally {
      busy = false;
    }
  }
</script>

<main class="login">
  <form class="card" onsubmit={submit} in:fly={{ y: 30, duration: 600, easing: backOut }}>
    {#key shake}
      <div class="brand" class:shake={shake > 0}>
        <span class="logo" aria-hidden="true">
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            ><path d="M4 7h16M4 11h16M4 15h9" /><path d="M19.5 17V5" /><circle
              cx="16.5"
              cy="17"
              r="3"
              fill="currentColor"
            /></svg
          >
        </span>
        <h1>Piano Sheets</h1>
        <p class="t2">Euer Notenpult für schöne Abende.</p>
      </div>
    {/key}

    {#if session.expiredNotice}
      <p class="notice">Deine Sitzung wurde beendet – bitte melde dich neu an.</p>
    {/if}

    <label class="field">
      E-Mail
      <input class="input" type="email" autocomplete="username" bind:value={email} required />
    </label>
    <label class="field">
      Passwort
      <input class="input" type="password" autocomplete="current-password" bind:value={password} required />
    </label>

    {#if error}
      <p class="error" role="alert">{error}</p>
    {/if}

    <button class="btn btn-primary submit" type="submit" disabled={busy}>
      {busy ? "Anmelden …" : "Anmelden"}
    </button>
  </form>
</main>

<style>
  .login {
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: calc(24px + var(--safe-top)) 20px calc(24px + var(--safe-bottom));
    background: radial-gradient(60% 50% at 50% 0%, rgba(77, 141, 255, 0.14), transparent 70%), var(--ground);
  }
  .card {
    width: min(100%, 400px);
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 28px;
    border-radius: 28px;
    background: var(--surface-2);
    box-shadow:
      var(--shadow-2),
      inset 0 0 0 1px var(--line);
  }
  .brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
    margin-bottom: 8px;
  }
  .brand.shake {
    animation: shake 0.45s var(--ease-out);
  }
  .logo {
    width: 58px;
    height: 58px;
    border-radius: 18px;
    background: var(--accent);
    color: var(--on-accent);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 16px 40px rgba(77, 141, 255, 0.35);
  }
  h1 {
    font-size: 28px;
  }
  .brand p {
    margin: 0;
    font-size: 14px;
  }
  .notice,
  .error {
    margin: 0;
    padding: 10px 14px;
    border-radius: var(--r-md);
    font-size: 14px;
    font-weight: 600;
  }
  .notice {
    background: var(--accent-soft);
    color: #bcd3ff;
  }
  .error {
    background: rgba(255, 107, 107, 0.12);
    color: #ffb4b4;
  }
  .submit {
    height: 50px;
    margin-top: 4px;
    font-size: 15px;
  }
  @keyframes shake {
    0%,
    100% {
      transform: none;
    }
    20% {
      transform: translateX(-8px);
    }
    40% {
      transform: translateX(7px);
    }
    60% {
      transform: translateX(-5px);
    }
    80% {
      transform: translateX(3px);
    }
  }
</style>
